import styled from 'styled-components'

//----- Component -----//
const InlineAd = styled.div`
	 {
		min-height: 280px;
	}
`

export const YourbowInline: React.FC<{
	adNumber: number | undefined
}> = ({ adNumber }) => {
	const suffix = adNumber ? `-${adNumber}` : 0
	return (
		<InlineAd
			className="ad-wrapper"
			id={`div-inline-ad${suffix}`}
			data-ad-mapping="inline"
			data-ad-slot="Discover/inline-ad"
		></InlineAd>
	)
}
